import React, { useState, useContext} from 'react';
import { Link, useHistory } from 'react-router-dom';
import {uiContext} from '../../components/common'
import './HeaderMenu.scss';

export function HeaderMenu(){
    /**
     * Componente HeaderMenu
     * Es quien provee al header de un menu de hamburgues conservando las misma opciones que Header
     */
    const [showMenu, setShowMenu] = useState(false);
    const [showSubMenu, setShowSubMenu] = useState(false)
    const history = useHistory();
    const uicontext = useContext(uiContext);
    const linksMenu = [
        {
            name: 'Acceso a caleta en línea',
            path:'/home'
        },
        {
            name: 'Áreas marinas protegidas',
            path:'/areas-marinas'
        },
        {
            name: 'Conservación y sustentabilidad',
            path:'/conservacion-sustentabilidad'
        },
        {
            name: 'Protocolo de COVID-19',
            path:'/protocolo-covid-19'
        },
        {
            target:'_blank',
            name: 'Manual de buenas prácticas',
            path:'http://www.sernapesca.cl/sites/default/files/manual_bbpp_version_final_0.pdf'
        },
        {
            name: 'Inscribe tu caleta aquí',
            path:'/registrar-caleta'
        },
    ]

  return (
    <div className="blueHeaderMasterContainer">
      <div className="blueHeaderSubContainer">
          <div style={{display: showMenu ? 'flex' : 'none'}} className='headerMainContainer-SubMenuVisible headerMainContainer-SubMenu'>
              <div className="SubMenuSubcontainer">
                  <div className="linksContainer">
                      {linksMenu.map((x, index) =>{
                          return !x.target ? 
                            <Link key={index} to={{pathname:x.path}} >{x.name}</Link> :
                            <a key={index} href={x.path} target='_blank'>{x.name}</a> 
                      })}
                  </div>
              </div>
          </div>
          <div className="dropDownMenu">
              <div className="leftSection"
              onClick={()=> setShowMenu(!showMenu)}>
                  <div className="hamburguerButtonContainer">
                      <div className={`hamburgerButton ${showMenu ? 'hamburgerButtonClose' : 'hamburgerButtonNormal'}`}>
                          <div className="bar0 bar"></div>
                          <div className="bar1 bar"></div>
                          <div className="bar2 bar"></div>
                      </div>
                  </div>
                  <span className="menuText">Menu</span>
              </div>
              <Link to={uicontext.login ? {} : {pathname:'/login'}} onClick={()=> uicontext.login ? setShowSubMenu(!showSubMenu):null} className="buttonEntrar">
                    {uicontext.login ? 'Cuenta': 'Entrar'}
                {showSubMenu && <div className="subMenu" style={{marginTop:240}}>
                    <div className="option">
                        <Link to={{pathname:'/mi-perfil'}} className="optionName textLink">Mi perfil</Link>
                    </div>
                    <div className="option">
                        <Link to={{pathname:'/new-product'}} className="optionName textLink">Mis productos</Link>
                    </div>
                    <div className="option">
                        <Link to={{pathname:'/change-password'}} className="optionName textLink">Cambiar contraseña</Link>
                    </div>
                    <div className="option">
                        <Link to={{pathname:'/'}} className="optionName textLink" onClick={() => {
                            localStorage.removeItem("sessionToken");
                            localStorage.removeItem("userId");
                            uicontext.setLogin(false);
                            }}>Salir</Link>
                    </div>
                </div>}
              </Link>
          </div>
      </div>
  </div>
  );
}